import { useContext } from 'react'
import { utils } from '@digital-commerce/shared-utils'
import { bool, object } from 'prop-types'

import localeContext from '../../../contexts/Locale'
import useTranslate from '../../../hooks/useTranslate'

import PriceBreakdownContainer from '../../molecules/CartItem/PriceBreakdown/PriceBreakdownContainer'
import ItemsPrice from '../../molecules/CartItem/PriceBreakdown/ItemsPrice'
import { FinalPrice } from '../../molecules/CartItem/PriceBreakdown'
import {
  buildAccessoryPenaltyCharges,
  buildOneTimeDiscount,
  buildOneTimeFinanceAmountCredit
} from './utils'
import NameAndPrice from '../../atoms/ItemDetails/NameAndPrice/NameAndPrice'
import OtherChargesAndCreditsContainer from '../../molecules/CartItem/PriceBreakdown/OtherChargesAndCreditsContainer'
import HeadingWithSubItems from '../../molecules/CartItem/PriceBreakdown/HeadingWithSubItems'

const { getItemOneTimePrice, getMonthlyItemPrice } = utils.cart

const OfferDetails = ({ mobAccessory, isFirstAccessoryInGroup, financedAccessoryGroup }) => {
  const translate = useTranslate()
  const { lang } = useContext(localeContext)

  const oneTimePrice = getItemOneTimePrice(mobAccessory)
  const dueTodaySubTotal = oneTimePrice.subTotal - oneTimePrice.credit
  const {
    duration: monthlyDuration,
    subTotal: dueMonthlySubTotal,
    amount: monthlyAmount
  } = getMonthlyItemPrice(mobAccessory) || {}

  const oneTimeDiscountData = buildOneTimeDiscount(mobAccessory, translate, lang)
  const oneTimeFinancedAmountCreditData = buildOneTimeFinanceAmountCredit(
    mobAccessory,
    translate,
    lang
  )
  const financedPenaltyChargesData = buildAccessoryPenaltyCharges(
    financedAccessoryGroup,
    translate,
    lang
  )

  const oneTimeDiscount = oneTimeDiscountData && (
    <NameAndPrice
      id={oneTimeDiscountData.id}
      name={oneTimeDiscountData.name}
      price={oneTimeDiscountData.price}
      prefixIcon={oneTimeDiscountData.prefixIcon}
    />
  )

  const oneTimeFinanceCredit = oneTimeFinancedAmountCreditData && (
    <NameAndPrice
      id={oneTimeFinancedAmountCreditData.id}
      name={oneTimeFinancedAmountCreditData.name}
      price={oneTimeFinancedAmountCreditData.price}
      prefixIcon={oneTimeFinancedAmountCreditData.prefixIcon}
    />
  )

  const financedPenaltyCharges = isFirstAccessoryInGroup && (
    <HeadingWithSubItems
      headingText={translate('additionalChargesAndCredits.pendingAmounts')}
      subItems={financedPenaltyChargesData}
    />
  )

  return (
    <>
      <PriceBreakdownContainer>
        <ItemsPrice
          items={[mobAccessory]}
          useDisplayNameOverride={translate('priceBreakdown.retailPrice')}
        />
        {oneTimeDiscount}
        {oneTimeFinanceCredit}
        <FinalPrice price={dueTodaySubTotal} />
        {monthlyAmount > 0 && (
          <>
            <ItemsPrice
              items={[mobAccessory]}
              isRecurring
              useDisplayNameOverride={`${translate('item.easyPayment', {
                replacements: { duration: monthlyDuration }
              })}`}
            />
            <FinalPrice price={dueMonthlySubTotal} isMonthly />
          </>
        )}
      </PriceBreakdownContainer>
      <OtherChargesAndCreditsContainer
        listData={[...(isFirstAccessoryInGroup ? financedPenaltyChargesData : [])]}
      >
        {financedPenaltyCharges}
      </OtherChargesAndCreditsContainer>
    </>
  )
}

export default OfferDetails

OfferDetails.propTypes = {
  mobAccessory: object.isRequired,
  isFirstAccessoryInGroup: bool,
  financedAccessoryGroup: object
}

OfferDetails.defaultProps = {
  isFirstAccessoryInGroup: false,
  financedAccessoryGroup: {}
}
